<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <UserManagement></UserManagement>
            </v-flex xs12>
        </v-layout>
    </v-container>
</template>

<script>
import UserManagement from "../../components/user/UserManagement.vue";

export default {
    components: {
        UserManagement
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    }
};
</script>

<style>
    
</style>